module.exports = __webpack_public_path__ + "files/29674bb70e13b2b8a3397d24129bbab8.png";